import { render } from "./MessagePopup.vue?vue&type=template&id=d38cc938&scoped=true"
import script from "./MessagePopup.vue?vue&type=script&lang=js"
export * from "./MessagePopup.vue?vue&type=script&lang=js"

import "./MessagePopup.vue?vue&type=style&index=0&id=d38cc938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d38cc938"]])

export default __exports__